import Hammer from 'hammerjs';
import { gsap } from 'gsap';
import store from '@/store';
import audio from './audio';

export default class Slider {
  constructor(container) {
    this.container = container;
    this.items = [...container.querySelectorAll('.slider__item')];
    this.currentIndex = 0;
    this.maxLength = this.items.length;
    this.isInTransition = false;

    this.hm = new Hammer(this.container);

    this.init();

    this.addEvents();
  }

  addEvents() {
    this.hm.on('swipeleft', () => this.animate(1));
    this.hm.on('swiperight', () => this.animate(-1));

    this.handlerKeydown = (e) => this.keydown(e);
    window.addEventListener('keydown', this.handlerKeydown);
  }

  init() {
    store.commit('SET_CHARACTER', this.items[0].dataset.id);

    gsap.set(this.items, {
      xPercent: (i) => i === 0 ? 0 : 100, // eslint-disable-line
      scale: (i) => i === 0 ? 1 : 0.5, // eslint-disable-line
      opacity: (i) => i === 0 ? 1 : 0, // eslint-disable-line
    });
  }

  animate(modificator) {
    if (this.isInTransition) return;
    this.isInTransition = true;

    if (modificator > 0) {
      this.items.push(this.items.shift());
    } else if (modificator < 0) {
      this.items.unshift(this.items.pop());
    }

    this.currentIndex = this.currentIndex + modificator < 0
      ? this.maxLength - 1 : (this.currentIndex + modificator) % this.maxLength;

    this.slideAnimation(modificator);
  }

  slideAnimation(modificator) {
    store.commit('SET_CHARACTER', this.items[0].dataset.id);
    audio.play('char-swipe');

    const tl = new gsap.timeline({ // eslint-disable-line
      onComplete: () => {
        this.isInTransition = false;
      },
    });

    tl.addLabel('start')
      .fromTo(this.items[0], {
        xPercent: modificator * 100,
        scale: 0.5,
        opacity: 0,
      }, {
        xPercent: 0,
        scale: 1,
        opacity: 1,
      }, 'start')
      .to(this.items[modificator > 0 ? this.maxLength - 1 : 1], {
        xPercent: (modificator * -1) * 100,
        scale: 0.5,
      }, 'start')
      .to(this.items[modificator > 0 ? this.maxLength - 1 : 1], {
        opacity: 0,
        duration: 0.3,
      }, 'start');
  }

  keydown(e) {
    switch (e.which) {
      case 37:
        this.animate(-1);
        break;

      case 39:
        this.animate(1);
        break;

      default:
        return; // eslint-disable-line
    }
  }

  destroy() {
    this.hm.off('swipeleft swiperight');
    window.removeEventListener('keydown', this.handlerKeydown);
  }
}
